import { render } from "./UpdateLTLOrder.vue?vue&type=template&id=1ccc4816&scoped=true&ts=true"
import script from "./UpdateLTLOrder.vue?vue&type=script&lang=ts"
export * from "./UpdateLTLOrder.vue?vue&type=script&lang=ts"

import "./UpdateLTLOrder.vue?vue&type=style&index=0&id=1ccc4816&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccc4816"]])

export default __exports__